import { DefaultActions } from "../../../../components/page-releated/grp-standard-screen/actions";
import { type StandardGrpColumns } from "../../../../layout/grp-standard-screen";

import { IZonesUseOccupation } from "../../../../shared/interfaces/IZonesUseOccupation";

const tableColumns: StandardGrpColumns<IZonesUseOccupation> = ({
    actionClick,
    columnClick,
}) => [
    {
        key: "action",
        name: "Ações",
        dataKey: "id",
        render(id) {
            return (
                <DefaultActions
                    value={id as unknown as number}
                    doAfterClick={actionClick}
                />
            );
        },
    },
    {
        key: "zoning.idzoneamento",
        dataKey: "idzoneamento",
        name: "Zoneamento",
        render(value, record) {
            return record.zoning?.zonas_tipo;
        },
        headerClick: columnClick,
    },
    {
        key: "zonas_use_occupation_nome",
        name: "Nome do índice urbanístico",
        dataKey: "zonas_use_occupation_nome",
        headerClick: columnClick,
    },
    {
        key: "zonas_use_occupation_valor",
        name: "Valor",
        dataKey: "zonas_use_occupation_valor",
        headerClick: columnClick,
    },
    {
        key: "zonas_use_occupation_observacao",
        name: "Observação",
        dataKey: "zonas_use_occupation_observacao",
        headerClick: columnClick,
    },
    {
        key: "zonas_use_occupation_ordem",
        name: "Ordem de exibição",
        dataKey: "zonas_use_occupation_ordem",
        headerClick: columnClick,
    },
    // {
    //     key: "idzoneamento",
    //     name: "ID do zoneamento",
    //     dataKey: "idzoneamento",
    //     headerClick: columnClick,
    // },
];

export default tableColumns;
